<template lang="pug">
#GlobalFooter
  p#Pagetop(style='display: none;' v-on:click="goToTop")
    a
      img.rover(:src='`${publicPath}assets/images/footer_btn_pagetop.png`' width='60' height='60' alt='ページ上部へ')
  .footer-top
    .footer-top-inline
      .bg-shadow01
        .footer-top-inner.cf
          dl.box
            dt
              img(:src='`${publicPath}assets/images/footer_ttl_explanation.png`' width='188' height='16' alt='説明会のご予約はこちら')
            dd
              a(href='/info-sessions/')
                span.ico
                  img(:src='`${publicPath}assets/images/footer_ico_explanation.png`' width='66' height='66' alt='無料')
                img.rover(:src='`${publicPath}assets/images/footer_btn_explanation.png`' width='304' height='64' alt='説明会のご予約')
          dl.box
            dt
              img(:src='`${publicPath}assets/images/footer_ttl_request.png`' width='141' height='16' alt='資料請求はこちら')
            dd
              a(href='/contact/request/' target='_blank')
                span.ico
                  img(:src='`${publicPath}assets/images/footer_ico_request.png`' width='66' height='66' alt='無料')
                img.rover(:src='`${publicPath}assets/images/footer_btn_request.png`' width='304' height='64' alt='資料請求')
          dl.box.tel
            dt
              img(:src='`${publicPath}assets/images/footer_ttl_tel.png`' width='236' height='16' alt='電話でのお問い合わせはこちら')
            dd
              img(:src='`${publicPath}assets/images/footer_txt_tel.png`' width='282' height='47' alt='フリーコール0120-188-335 10：00～19：00(土・日・祝を除く)')
  .footer-bottom
    .footer-bottom-inline
      .footer-bottom-inner
        .sitemap.cf
          ul
            li.list
              a(href='/business/') 塾を経営するということ
              ul
                li
                  a(href='/business/message/') FC本部からのメッセージ
            li.list.wao
              a(href='/wao/') ワオ・コーポレーションについて
              ul
                li
                  a(href='/wao/activity/') 未来へ続く教育活動
                li
                  a(href='/wao/company/') 会社概要
            li.list
              a(href='/advantage/') アクシスの強み
              ul
                li
                  a(href='/advantage/system/' style="white-space:nowrap") 合格実績を出せる学習システム
                li
                  a(href='/advantage/strategy/') 地域別戦略
            li.list
              a(href='/plan/') アクシス開業の仕組み
              ul
                li
                  a(href='/plan/diagnose/') 立地診断
                li
                  a(href='/plan/step/') 開校までのステップ
                li
                  a(href='/plan/equipment/') 校舎・設備
            li.list
              a(href='/support/') 手厚いサポート体制
              ul
                li
                  a(href='/support/training/') オーナー研修制度
                li
                  a(href='/support/adoption/') 講師の採用・研修制度
            li.list.work
              a(href='/work/') オーナーの仕事
              ul
                li
                  a(href='/work/voice/') オーナーの声
        .footer-link.cf
          .left-cont
            ul.bnr-area.all-rover
              li
                a(href='http://www.wao-corp.com/' target='_blank')
                  img(:src='`${publicPath}assets/images/footer_bnr_wao.png`' width='140' height='45' alt='ワオ・コーポレーション')
              li
                a(href='http://axis-kobetsu.jp/' target='_blank')
                  img(:src='`${publicPath}assets/images/footer_bnr_axis.png`' width='140' height='45' alt='個別指導AXIS')
          .right-cont
            ul.footer-nav
              li
                a(href='/privacy/') 個人情報保護方針
              li
                a(href='/policy/') プライバシーポリシー
            p.copyright
              small
                img(:src='`${publicPath}assets/images/footer_txt_copyright.png`' width='322' height='15' alt='Copyright(C)ワオ・コーポレーション All rights reserved.')
</template>

<style lang="scss">
#GlobalFooter ul, #GlobalFooter ol {
    padding-left: 0;
}
</style>

<script>
import $ from "jquery"
import goTo from 'vuetify/es5/services/goto'

export default {
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    mounted: function () {
        const io = new IntersectionObserver(cb)

        io.observe(document.querySelector("#GlobalHeader"))

        function cb (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    $("#Pagetop").fadeIn();
                } else {
                    $("#Pagetop").fadeOut();
                }
            })
        }
    },

    methods: {
        goToTop: function() {
            goTo(0);
        }
    }
}
</script>